function useService(options) {
  const callbacks = /* @__PURE__ */ new Map();
  let isInit = false;
  const { init, kill, props } = options;
  function has(key) {
    return callbacks.has(key);
  }
  function get(key) {
    return callbacks.get(key);
  }
  function add(key, callback) {
    if (has(key)) {
      console.warn(`The key \`${key}\` has already been added.`);
      return;
    }
    if (callbacks.size === 0 && !isInit) {
      init();
      isInit = true;
    }
    callbacks.set(key, callback);
  }
  function remove(key) {
    callbacks.delete(key);
    if (callbacks.size === 0 && isInit) {
      kill();
      isInit = false;
    }
  }
  function trigger(p) {
    callbacks.forEach(function forEachCallback(callback) {
      callback(p);
    });
  }
  return {
    callbacks,
    props,
    add,
    remove,
    has,
    get,
    trigger
  };
}
export {
  useService
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
